import { render, staticRenderFns } from "./wayTestE.vue?vue&type=template&id=0c666ff5&scoped=true&"
import script from "./wayTestE.vue?vue&type=script&lang=js&"
export * from "./wayTestE.vue?vue&type=script&lang=js&"
import style0 from "./wayTestE.vue?vue&type=style&index=0&id=0c666ff5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c666ff5",
  null
  
)

export default component.exports